function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#1F619E"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.035 5.368c.62-.063 1.11-.582 1.11-1.184A1.248 1.248 0 008.908 3c-.683 0-1.217.54-1.217 1.184 0 .207.064.394.15.581l.426 5.96h4.485l1.836 4.196L17 14.007l-.385-.872-1.324.457-1.772-3.988-4.164.021-.085-.748h3.01V7.756H9.143c.021 0-.107-2.388-.107-2.388z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.541 13.924c-.747 1.454-2.349 2.41-4.036 2.41C7.028 16.333 5 14.36 5 11.95c0-1.703 1.046-3.281 2.626-3.967l.107 1.288a3.17 3.17 0 00-1.516 2.68c0 1.744 1.473 3.177 3.267 3.177 1.644 0 3.053-1.226 3.246-2.804l.811 1.6z",
  fill: "#fff"
});

function SvgAccessibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgAccessibility;